import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';

import Form from './Form';
import graph from './graph';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { useLazyQuery, useMutation } from '@apollo/client';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';

export default function UpdatePopup({ ids, title, refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState(true);
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [updateModel, { loading: updating }] = useMutation(graph.update.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids,
          for_admin: 1,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { code, title, is_active } = res;
        if (res) {
          setFormData({
            code,
            title,
            is_active: Number(is_active),
          });
        }
      }
    } catch (error) {}
  };

  const onChange = ({ formData, errors }) => {
    setFormData(formData);
    setFormError(Boolean(errors.length > 0));
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await updateModel({
        context: {
          serviceName: graph.update.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids,
          ...formData,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.update.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Tooltip title={<FormattedMessage id={title} />}>
        <IconButton size="small" color="info" onClick={onOpen} sx={{ bgcolor: 'action.hover' }}>
          <ModeEditRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <NewDialog label="update" open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack rowGap={2} height="100%" alignItems="center" justifyContent="center">
                <CircularProgress size={20} color="inherit" />
                <Typography align="center" variant="caption" color="text.disabled">
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <Form formData={formData} onChange={onChange} />
            )}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            color="primary"
            variant="contained"
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
            disabled={loading || updating || formError}
          >
            <FormattedMessage id="update" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
